import { getAdminSettingsDB } from '../services/db.js';
import { setCurrentUser } from '../auth.js';
import { navigate } from '../router.js';
import { toastSuccess, toastError } from '../components/toast.js';

export async function renderAdminLogin() {
  const app = document.getElementById('app');
  app.innerHTML = `
    <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:100dvh; padding:var(--space-xl); background:var(--bg-dark);">
      <div style="width:100%; max-width:400px; text-align:center;">
        <div style="font-size:3rem; margin-bottom:var(--space-sm);">🔒</div>
        <h2 style="color:var(--accent-gold); margin-bottom:var(--space-xs);">เข้าสู่ระบบจัดการ</h2>
        <p class="text-sm text-muted mb-xl">กรุณากรอกรหัส PIN 6 หลัก</p>
        
        <div class="form-group">
          <input type="password" id="admin-pin" class="form-input" 
                 style="text-align:center; font-size:2rem; letter-spacing:0.5rem; padding:var(--space-md);" 
                 maxlength="6" inputmode="numeric" placeholder="••••••" />
        </div>
        
        <button id="login-btn" class="btn btn-gold btn-block mt-lg" style="font-size:1.1rem; padding:var(--space-md);">
          เข้าสู่ระบบ
        </button>
        
        <button id="back-btn" class="btn btn-outline btn-block mt-md">
          🏠 กลับหน้าหลัก (สำหรับลูกค้า)
        </button>
      </div>
    </div>
  `;

  document.getElementById('back-btn').addEventListener('click', () => {
    // Navigate home will probably trigger reload because normally LIFF is needed
    // The easiest is just window.location.href = '/' to reload fully out of PIN mode
    window.location.href = window.location.pathname;
  });

  document.getElementById('login-btn').addEventListener('click', async () => {
    const pin = document.getElementById('admin-pin').value;
    if (pin.length !== 6) {
      toastError('กรุณากรอก PIN ให้ครบ 6 หลัก');
      return;
    }

    const btn = document.getElementById('login-btn');
    btn.disabled = true;
    btn.textContent = '⏳ กำลังตรวจสอบ...';

    // Verify PIN against DB
    let expectedPin = '888888';
    try {
      const settings = await getAdminSettingsDB();
      if (settings && settings.system_pin) {
        expectedPin = settings.system_pin;
      }
    } catch (e) {
      console.warn('Could not fetch settings, using default pin');
    }

    if (pin === expectedPin) {
      toastSuccess('เข้าสู่ระบบสำเร็จ');
      localStorage.setItem('app_pin_auth', 'true');
      
      // Upgrade session silently
      setCurrentUser({
        id: 'admin_pin_user',
        name: 'Admin (PIN)',
        role: 'admin',
        pictureUrl: 'https://ui-avatars.com/api/?name=A&background=e94d9e&color=fff&size=150'
      });
      
      navigate('/admin/bookings');
    } else {
      toastError('รหัส PIN ไม่ถูกต้อง');
      btn.disabled = false;
      btn.textContent = 'เข้าสู่ระบบ';
      document.getElementById('admin-pin').value = '';
    }
  });

  // Auto enter on 6 chars
  document.getElementById('admin-pin').addEventListener('input', (e) => {
    if (e.target.value.length === 6) {
      document.getElementById('login-btn').click();
    }
  });
}
